import type { Article } from '@/features/article/components/article-card';
import type { MediaAuthorArticleListItem } from '@/features/media-authors/types';

const DEFAULT_HERO_IMAGE_URL = '/molwe.webp';

/**
 * Maps a media-author article list item to the ArticleCard model.
 */
export const toArticleCardModel = (item: MediaAuthorArticleListItem): Article => {
  const imageUrl = item.heroImageUrl || DEFAULT_HERO_IMAGE_URL;
  return {
    id: item.id,
    slug: item.slug,
    title: item.title,
    description: item.description,
    category: '',
    author: item.populatedAuthors[0]?.name || 'Molwe',
    date: item.publishedAt,
    heroImage: {
      id: 0,
      alt: item.title,
      caption: null,
      updatedAt: item.publishedAt,
      createdAt: item.publishedAt,
      url: imageUrl,
      thumbnailURL: imageUrl,
      filename: 'cover',
      mimeType: 'image/png',
      filesize: 0,
      width: 860,
      height: 480,
      focalX: 50,
      focalY: 50,
      sizes: {
        thumbnail: {
          url: imageUrl,
          width: 300,
          height: 300,
          mimeType: 'image/png',
          filesize: 0,
          filename: 'thumb',
        },
        square: {
          url: imageUrl,
          width: 300,
          height: 300,
          mimeType: 'image/png',
          filesize: 0,
          filename: 'square',
        },
        small: {
          url: imageUrl,
          width: 640,
          height: 360,
          mimeType: 'image/png',
          filesize: 0,
          filename: 'small',
        },
        medium: {
          url: imageUrl,
          width: 860,
          height: 480,
          mimeType: 'image/png',
          filesize: 0,
          filename: 'medium',
        },
        large: {
          url: imageUrl,
          width: 1200,
          height: 675,
          mimeType: 'image/png',
          filesize: 0,
          filename: 'large',
        },
        xlarge: {
          url: null,
          width: null,
          height: null,
          mimeType: null,
          filesize: null,
          filename: null,
        },
        og: {
          url: imageUrl,
          width: 1200,
          height: 630,
          mimeType: 'image/png',
          filesize: 0,
          filename: 'og',
        },
      },
    },
    type: item.type,
    populatedAuthors: item.populatedAuthors.map((author) => ({
      id: author.id ?? 0,
      name: author.name,
      avatar: author.avatar ?? undefined,
      slug: author.slug,
      url: author.url,
      isActive: author.isActive ?? author.isPublished,
      isPublished: author.isActive ?? author.isPublished,
    })),
    fandoms: [],
    publishedAt: item.publishedAt,
    tags: [],
  };
};
